var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChocolateBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 60 60",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.82 14.47h9.34v5.47h-9.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.16 14.47h7.33v5.47h-7.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.49 14.47h9.34v5.47h-9.34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.16 5h-8.34c-.55 0-1 .45-1 1v6.47h9.34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.16 5h7.33v7.47h-7.33z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44.83 6c0-.55-.45-1-1-1h-8.34v7.47h9.34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m43.99 35.86c-.86.3-1.93.68-3.35 1.03-1.01.26-1.74.7-2.52 1.18-1.36.82-3.04 1.84-5.81 1.84-.74 0-1.54-.07-2.38-.22l-.53-.09c-1.29-.23-2.06-.36-2.52-.36-.36 0-.6.1-1.76.64l-.19.09c-.56.26-1.24.58-2.1.95-1.89.82-3.82 1.23-5.74 1.23-.83 0-1.59-.08-2.27-.2v12.05c0 .32.15.62.41.81.18.13.38.19.59.19.1 0 .21-.01.31-.04l3.2-1.03 3.2 1.03c.2.06.41.06.61 0l3.2-1.03 3.19 1.03c.2.06.41.06.61 0l3.19-1.03 3.19 1.03c.2.06.42.06.61 0l3.2-1.03 3.19 1.03c.31.09.64.04.9-.15s.41-.49.41-.81v-18.42c-.18.06-.37.12-.59.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m26.16 26.81 7.33-1.73v-3.14h-7.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m35.49 24.61 7.65-1.81c.22-.05.45-.08.69-.08.35 0 .68.07 1 .18v-.96h-9.34z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m14.82 29.52c.12-.04.23-.09.35-.12l8.99-2.12v-5.34h-9.34z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m44.72 25.27c-.2-.41-.67-.63-1.12-.52l-28.01 6.61c-.28.06-.52.25-.66.51l-3 5.84c-.24.47-.07 1.05.38 1.32.12.07 1.96 1.12 4.78 1.12 1.43 0 3.11-.27 4.94-1.06.94-.41 1.66-.75 2.24-1.02 2.18-1.02 2.18-1.02 5.46-.44l.54.09c3.56.62 5.21-.39 6.81-1.36.87-.53 1.78-1.08 3.08-1.41 1.41-.35 2.47-.73 3.33-1.03 1.54-.53 2.31-.81 3.45-.52.38.1.78-.03 1.03-.34.24-.3.29-.72.11-1.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolateBar);
export default __webpack_public_path__ + "static/media/chocolate-bar.ea5d9b495aa50640695960cda1e5745f.svg";
export { ForwardRef as ReactComponent };